/* Redux */
import { useSelector, useDispatch } from 'src/redux/hooks'

const Redux = () => {

  const warenkorbItems = useSelector(store =>
    Object.values(store.Warenkorb.items).reduce((total, { qty }) => total + qty, 0)
  )

  const wunschlisteItems = useSelector(store => Object.keys(store.Wunschliste.items).length)

  const dispatch = useDispatch()

  const toggleDrawer = () =>
    dispatch({ type: 'navigationDrawerToggle', payload: true })
  const openMenuDrawer = () => {
    dispatch({ type: 'navigationFilterToggle', payload: false })
    dispatch({ type: 'navigationMenuChange', payload: 0 })
    dispatch({ type: 'navigationDrawerToggle', payload: true })
  }

  const showMobileSuche = useSelector(store => store.App.showMobileSuche)
  const openSearchOverlay = () =>
    dispatch({ type: 'mobileSucheToggle', payload: true })
  const closeSearchOverlay = () =>
    dispatch({ type: 'mobileSucheToggle', payload: false })

  const userToken = useSelector(store => store.User.token)

  return {
    toggleDrawer,
    openMenuDrawer,
    showMobileSuche,
    openSearchOverlay,
    closeSearchOverlay,
    warenkorbItems, wunschlisteItems,
    userToken,
  }
  
}

export default Redux
